import { render, staticRenderFns } from "./StudyDetail.vue?vue&type=template&id=6808ffd0&scoped=true&lang=pug"
import script from "./StudyDetail.vue?vue&type=script&lang=ts"
export * from "./StudyDetail.vue?vue&type=script&lang=ts"
import style0 from "./StudyDetail.vue?vue&type=style&index=0&id=6808ffd0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808ffd0",
  null
  
)

export default component.exports